@if (ticket) {
  @let showTicketStatus = ticket?.status?.status_id !== TicketStatusId.STATUS_NEW;
  @if (showTicketStatus) {
    <app-ticket-status [ticket]="ticket"
                       [fontSize]="fontSize"
                       [hidePriority]="hidePriority"
                       [contentPosition]="singlePill ? 'inside' : 'outside'">
      @if (alwaysDisplayFaultStatus) {
        <ng-template #contentTemplate>
          <ng-template [ngTemplateOutlet]="singlePill ? faultStatusTextTemplate : faultStatusTemplate"/>
        </ng-template>
      }
    </app-ticket-status>
  } @else {
   <ng-template [ngTemplateOutlet]="faultStatusTemplate"/>
  }
}

<!-- Single line to get rid of unintended spaces -->
<ng-template #faultStatusTemplate let-textOnly="textOnly"><app-alert-fault-status [textOnly]="textOnly ?? false" [faultStatus]="ticket.fault_status"/></ng-template>

<ng-template #faultStatusTextTemplate>
  <span class="fw-normal">
    (<ng-template [ngTemplateOutlet]="faultStatusTemplate" [ngTemplateOutletContext]="{textOnly: true}"/>)
  </span>
</ng-template>